export const primaryDates = [
  { state: 'AL', name: 'Alabama', primary: '2026-05-19', runoff: '2026-06-16' },
  { state: 'AK', name: 'Alaska', primary: '2026-08-18', runoff: null },
  { state: 'AZ', name: 'Arizona', primary: '2026-07-21', runoff: null },
  { state: 'AR', name: 'Arkansas', primary: '2026-03-03', runoff: '2026-03-31' },
  { state: 'CA', name: 'California', primary: '2026-06-02', runoff: null },
  { state: 'CO', name: 'Colorado', primary: '2026-06-30', runoff: null },
  { state: 'CT', name: 'Connecticut', primary: '2026-08-11', runoff: null },
  { state: 'DE', name: 'Delaware', primary: '2026-09-15', runoff: null },
  { state: 'FL', name: 'Florida', primary: '2026-08-18', runoff: null },
  { state: 'GA', name: 'Georgia', primary: '2026-05-19', runoff: '2026-06-16' },
  { state: 'HI', name: 'Hawaii', primary: '2026-08-08', runoff: null },
  { state: 'ID', name: 'Idaho', primary: '2026-05-19', runoff: null },
  { state: 'IL', name: 'Illinois', primary: '2026-03-17', runoff: null },
  { state: 'IN', name: 'Indiana', primary: '2026-05-05', runoff: null },
  { state: 'IA', name: 'Iowa', primary: '2026-06-02', runoff: null },
  { state: 'KS', name: 'Kansas', primary: '2026-08-04', runoff: null },
  { state: 'KY', name: 'Kentucky', primary: '2026-05-19', runoff: null },
  { state: 'LA', name: 'Louisiana', primary: '2026-05-16', runoff: '2026-06-27' },
  { state: 'ME', name: 'Maine', primary: '2026-06-09', runoff: null },
  { state: 'MD', name: 'Maryland', primary: '2026-06-23', runoff: null },
  { state: 'MA', name: 'Massachusetts', primary: '2026-09-01', runoff: null },
  { state: 'MI', name: 'Michigan', primary: '2026-08-04', runoff: null },
  { state: 'MN', name: 'Minnesota', primary: '2026-08-11', runoff: null },
  { state: 'MS', name: 'Mississippi', primary: '2026-03-10', runoff: '2026-04-07' },
  { state: 'MO', name: 'Missouri', primary: '2026-08-04', runoff: null },
  { state: 'MT', name: 'Montana', primary: '2026-06-02', runoff: null },
  { state: 'NE', name: 'Nebraska', primary: '2026-05-12', runoff: null },
  { state: 'NV', name: 'Nevada', primary: '2026-06-09', runoff: null },
  { state: 'NH', name: 'New Hampshire', primary: '2026-09-08', runoff: null },
  { state: 'NJ', name: 'New Jersey', primary: '2026-06-02', runoff: null },
  { state: 'NM', name: 'New Mexico', primary: '2026-06-02', runoff: null },
  { state: 'NY', name: 'New York', primary: '2026-06-23', runoff: null },
  { state: 'NC', name: 'North Carolina', primary: '2026-03-03', runoff: '2026-05-12' },
  { state: 'ND', name: 'North Dakota', primary: '2026-06-09', runoff: null },
  { state: 'OH', name: 'Ohio', primary: '2026-05-05', runoff: null },
  { state: 'OK', name: 'Oklahoma', primary: '2026-06-16', runoff: '2026-08-25' },
  { state: 'OR', name: 'Oregon', primary: '2026-05-19', runoff: null },
  { state: 'PA', name: 'Pennsylvania', primary: '2026-05-19', runoff: null },
  { state: 'RI', name: 'Rhode Island', primary: '2026-09-08', runoff: null },
  { state: 'SC', name: 'South Carolina', primary: '2026-06-09', runoff: '2026-06-23' },
  { state: 'SD', name: 'South Dakota', primary: '2026-06-02', runoff: '2026-07-28' },
  { state: 'TN', name: 'Tennessee', primary: '2026-08-06', runoff: null },
  { state: 'TX', name: 'Texas', primary: '2026-03-03', runoff: '2026-05-26' },
  { state: 'UT', name: 'Utah', primary: '2026-06-23', runoff: null },
  { state: 'VT', name: 'Vermont', primary: '2026-08-11', runoff: null },
  { state: 'VA', name: 'Virginia', primary: '2026-08-04', runoff: null },
  { state: 'VA-RD', name: 'Virginia Redistricting', primary: '2026-04-21', runoff: null },
  { state: 'WA', name: 'Washington', primary: '2026-08-04', runoff: null },
  { state: 'WV', name: 'West Virginia', primary: '2026-05-12', runoff: null },
  { state: 'WI', name: 'Wisconsin', primary: '2026-08-11', runoff: null },
  { state: 'WY', name: 'Wyoming', primary: '2026-08-18', runoff: null },
]

/** Parse YYYY-MM-DD as local calendar date (avoids UTC shift in browsers). */
export const parseLocalDate = (dateStr) => {
  return new Date(dateStr + 'T00:00:00')
}

// Helper functions
export const getPrimaryByState = (stateAbbr) => {
  return primaryDates.find(p => p.state === stateAbbr?.toUpperCase())
}

export const getDaysUntilPrimary = (stateAbbr) => {
  const stateData = getPrimaryByState(stateAbbr)
  if (!stateData) return null
  
  const today = new Date()
  today.setHours(0, 0, 0, 0)  // Normalize to start of day
  const primary = parseLocalDate(stateData.primary)
  const diffTime = primary - today
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
  
  return diffDays
}

export const getUpcomingPrimaries = (days = 30) => {
  const today = new Date()
  today.setHours(0, 0, 0, 0)
  return primaryDates
    .filter(p => {
      const primary = parseLocalDate(p.primary)
      const diffDays = Math.ceil((primary - today) / (1000 * 60 * 60 * 24))
      return diffDays >= 0 && diffDays <= days
    })
    .sort((a, b) => parseLocalDate(a.primary) - parseLocalDate(b.primary))
}

export const getPrimariesByMonth = () => {
  const grouped = {}
  primaryDates.forEach(p => {
    const date = parseLocalDate(p.primary)
    const monthKey = date.toLocaleString('default', { month: 'long', year: 'numeric' })
    if (!grouped[monthKey]) grouped[monthKey] = []
    grouped[monthKey].push(p)
  })
  
  Object.keys(grouped).forEach(month => {
    grouped[month].sort((a, b) => parseLocalDate(a.primary) - parseLocalDate(b.primary))
  })
  
  return grouped
}